import { useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate';

import {
  ClaimLoyaltyPromotionDocument,
  type ClaimLoyaltyPromotionMutation,
  type ClaimLoyaltyPromotionMutationVariables,
} from '../../../../graphql/ClaimOffer.generated';
import { type ClaimOfferInput, type ClaimOfferResponse } from '../../click-to-claim.machine.types';

// ─────────────────────────────────────────────────────────────────────────────

export const useClaimOfferActor = () => {
  const client = useClient();

  const claimOffer = useMemo(
    () =>
      fromPromise<ClaimOfferResponse, ClaimOfferInput>(async (event) => {
        const mutation = client.mutation<
          ClaimLoyaltyPromotionMutation,
          ClaimLoyaltyPromotionMutationVariables
        >;

        const variables: ClaimLoyaltyPromotionMutationVariables = {
          input: { offerId: event.input.offerId },
        };

        const response = await mutation(ClaimLoyaltyPromotionDocument, variables).toPromise();

        const claim = response.data?.claimLoyaltyPromotion;

        if (!claim) {
          throw response.error ?? new Error(INVALID_RESULT_MESSAGE);
        }

        if (claim.__typename === 'Reward') {
          return { result: claim.__typename, reward: claim };
        }

        return {
          result: claim.__typename,
          reason: claim.reason,
          errorMessage: claim.errorMessage,
        };
      }),
    [client.mutation],
  );

  return {
    claimOffer,
  };
};

// ─── Constants ───────────────────────────────────────────────────────────────

const INVALID_RESULT_MESSAGE = 'Invalid claimLoyaltyPromotion result';
